import React from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

import contextTypes from 'bundles/email/context_types';
import { mapId, mapName } from 'helpers/react_select_helpers';

class DesignSelect extends React.Component {
  static propTypes = {
    design: PropTypes.object.isRequired,
    designs: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);

    const propertyDesigns = [];
    const multiPropertyDesigns = [];
    const spaceNeedsDesigns = [];
    for (const design of props.designs) {
      if (design.contextType === contextTypes.propertyEmail) {
        propertyDesigns.push(design);
      } else if (design.contextType === contextTypes.multiPropertyEmail) {
        multiPropertyDesigns.push(design);
      } else if (design.contextType === contextTypes.spaceNeedsEmail) {
        spaceNeedsDesigns.push(design);
      }
    }

    this.options = [
      { label: 'Property', options: propertyDesigns },
      { label: 'Multi-Property', options: multiPropertyDesigns },
      { label: 'Space Needs', options: spaceNeedsDesigns }
    ];
  }

  render() {
    return (
      <div className="design-option-defaults-control">
        <span>Choose Email Template Theme:</span>
        <Select
          getOptionLabel={mapName}
          getOptionValue={mapId}
          menuPosition="fixed"
          options={this.options}
          value={this.props.design}
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}

export default DesignSelect;
